import { FC } from "react";
import { ShareIssuePerShareTypeModel } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { VBox } from "../../components-v2/Box";
import { FixedOrInterval } from "./FixedOrInterval";
import { NumberField, NumberQuestion } from "../common/commonComponents";
import { CURRENCY_NOK } from "../../utils/currency";

import { useTranslation } from "../../stores/RootStoreContext";
import { shareTypeLabel } from "../../common/share";

const ShareIssueForShareType: FC<{ model: ShareIssuePerShareTypeModel; isLocked: boolean }> =
  observer(({ model, isLocked }) => {
    const { t } = useTranslation();
    return (
      <>
        <div>
          {t("dbot.sharecapitalIncrease.forSharetype", {
            shareType: t(shareTypeLabel(model.sharetypeCode)),
          })}
        </div>

        <FixedOrInterval form={model} isLocked={isLocked} />

        {model.showShareIssueFixed && (
          <NumberField
            label={t("decisions.number-of-shares")}
            field={model.fixed.numberOfShares}
            onBlur={model.setSubscribersForIssue}
            isLocked={isLocked}
          />
        )}
        {model.showShareIssueInterval && (
          <VBox>
            <NumberField
              label={t("decisions.from")}
              field={model.interval.from}
              isLocked={isLocked}
              inline
            />
            <NumberField
              label={t("decisions.to")}
              field={model.interval.to}
              onBlur={model.setSubscribersForIssue}
              isLocked={isLocked}
              inline
            />
          </VBox>
        )}
        {<SubscriptionPrice model={model} isLocked={isLocked} />}
        <hr />
      </>
    );
  });

const SubscriptionPrice: FC<{ model: ShareIssuePerShareTypeModel; isLocked: boolean }> = observer(
  ({ model, isLocked }) => {
    const { t } = useTranslation();
    return (
      <>
        <NumberQuestion
          question={t(
            "decisions.increaseShareCapitalAgainstCash.newShares.subscriptionValue.title",
          )}
          label={t("decisions.enter-amount")}
          prefix={CURRENCY_NOK}
          field={model.sharePrice}
          onBlur={model.setSubscribersForIssue}
          isLocked={isLocked}
        />
      </>
    );
  },
);

export default ShareIssueForShareType;
